import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function partition<T>(
  array: T[],
  predicate: (item: T) => boolean
): [T[], T[]] {
  return array.reduce(
    ([pass, fail], item) => {
      if (predicate(item)) {
        pass.push(item);
      } else {
        fail.push(item);
      }
      return [pass, fail];
    },
    [[], []] as [T[], T[]]
  );
}
